<template>
  <div class="login-container">
  </div>
</template>

<script>
  // Vuex
  import { get, sync } from 'vuex-pathify'
  import crypto from 'crypto-js'

  export default {
    data: () => ({
      loading: false,
    }),
    computed: {
      ...sync('user', [
        'info',
        'token',
      ]),
      ...get('user', [
        'info',
        'token',
      ]),
      ...get('app', [
        'items',
      ]),
    },
    async created () {
      await this.login()
    },
    async mounted () {
      const user = this.$cookies.get('user')
      try {
        if (user) {
          this.$store.set('user/info', user)
          this.$store.set('user/token', user.token)
          this.$router.replace(this.items[0].to)
        }
      } catch (err) {
        // alert(err)
      }
    },
    methods: {
      async login () {
        this.$http.post('/api/sso/login', { hashEmail: this.$route.params.hashEmail }).then((response) => {
          this.loginSuccess(response)
        }).catch(error => {
          alert(error.response.data.error)
          this.$router.replace('/')
        })
      },

      async loginSuccess (response) {
        this.$store.set('user/info', response.data.user)
        this.$store.set('user/token', response.data.token)

        this.$cookies.set('user', { ...response.data.user, token: response.data.token }, 0)
        this.$http.defaults.headers.common.Authorization = 'Bearer ' + response.data.token
        setTimeout(() => {
          if (this.token) {
            this.$router.replace(this.items[0].to)
          }
          this.loading = false
        }, 500)
      },
    },
  }
</script>
